function formatCurrency(number) {
	if (!number) return '';
	let locale  = localStorage.getItem('locale') || 'no';
	if (locale === 'no') {
		locale = 'nb';
	}
	return new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(number);
}

export default formatCurrency;